import React from 'react';

const AboutSection = () => {
  return (
    <section id="about" className="py-16 sm:py-20 bg-gradient-to-br from-cream-50 to-burlap-50 px-4 sm:px-6">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-12">
          <span className="text-sm font-bold text-primary-600 uppercase tracking-wider bg-primary-100 px-4 py-2 rounded-full mb-4 inline-block">
            About Us
          </span>
          <h2 className="text-3xl sm:text-4xl font-display font-bold text-burlap-800 mb-6">
            Premium Gifting <span className="gradient-gold">Solutions</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <div className="prose prose-lg max-w-none">
              <p className="text-lg text-burlap-700 leading-relaxed mb-6">
                Kalaratan's Gifts delivers premium gifting solutions that leave a lasting impression. 
                Specializing in corporate gifting, festive hampers, and elegant return gifts, we help 
                businesses and individuals celebrate every occasion with style and thoughtfulness.
              </p>
              
              <p className="text-lg text-burlap-700 leading-relaxed mb-6">
                From Diwali hampers for employees and clients to personalized return gifts for weddings, 
                engagements, and housewarmings, our curated selections combine quality, tradition, and 
                modern aesthetics. Each gift is designed to create memorable experiences and strengthen relationships.
              </p>
              
              <p className="text-lg text-burlap-700 leading-relaxed mb-8">
                Whether you're looking to appreciate your team, delight your clients, or celebrate life's 
                special moments, Kalaratan's Gifts makes gifting effortless, meaningful, and unforgettable.
              </p>
            </div>

            {/* Specializations */}
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 border border-cream-200">
              <h3 className="text-xl font-bold text-burlap-800 mb-4 font-display">Specialized in:</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {[
                  'Corporate Gifting Solutions',
                  'Festival & Event Hampers', 
                  'Return Gifts for Weddings & Celebrations',
                  'Personalized Gifts & Premium Packaging'
                ].map((specialization, index) => (
                  <div key={index} className="flex items-center space-x-3">
                    <span className="w-2 h-2 bg-primary-500 rounded-full"></span>
                    <span className="text-burlap-700 font-medium">{specialization}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Visual Element */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              {[
                { img: '/gifts/IMG-20250903-WA0054.jpg', title: 'Corporate Excellence' },
                { img: '/gifts/IMG-20250903-WA0072.jpg', title: 'Premium Hampers' },
                { img: '/gifts/IMG-20250903-WA0075.jpg', title: 'Return Gifts' },
                { img: '/gifts/IMG-20250903-WA0068.jpg', title: 'Personalized Items' }
              ].map((item, index) => (
                <div key={index} className="relative group">
                  <div className="aspect-square bg-gradient-to-br from-burlap-100 to-burlap-200 rounded-xl overflow-hidden border-2 border-cream-200 shadow-lg group-hover:shadow-xl transition-all duration-300">
                    <img 
                      src={item.img} 
                      alt={item.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'flex';
                      }}
                    />
                    <div className="w-full h-full bg-gradient-to-br from-primary-100 to-primary-200 rounded-xl flex items-center justify-center hidden">
                      <span className="text-2xl text-primary-400">🎁</span>
                    </div>
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl flex items-end">
                    <p className="text-white text-sm font-semibold p-3">{item.title}</p>
                  </div>
                </div>
              ))}
            </div>
            
            {/* Decorative element */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-gradient-to-br from-primary-400 to-accent-400 rounded-full opacity-20 animate-pulse"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
